import { DeleteOutlined} from "@ant-design/icons"
import { Button, Col, Divider, Empty, Input, Modal, Row, Table } from "antd"
import {useContext, useState} from "react"
import apiMaestras from "../../../../api/Maestras/api-maestras"
import { Criterios } from "../../../../models/Maestras/maestras.model"
import { openNotification } from "../../../../utils/Notifactions"
import {TemplateContext} from "../../../../utils/template_context";

interface IModalCriterios {
    openModal: boolean,
    setOpenModal: Function,
    isEdit: boolean,
    criterios: Criterios[],
    obtenerCriterios: Function,
    datos: Criterios,
    setDatos: Function,
}

export const ModalCriterios = ({ openModal, setOpenModal, isEdit, criterios, obtenerCriterios, datos, setDatos }: IModalCriterios) => {

    const context = useContext(TemplateContext);

    const [criterio, setCriterio] = useState<Criterios>({
        nombre: ''
    })



    const addCriterio = async () => {
        if (criterio.nombre !== '') {
            try {
                const data = await apiMaestras.crearCriterio(criterio);
                if(!data.ok){
                    return openNotification({
                        titulo: "Error",
                        descripcion: data.message,
                        placement: "bottomRight",
                      })
                }
                obtenerCriterios();
                setCriterio({
                    nombre: ''
                })
            } catch (error) {
                console.log(error);
            }
        }
    }



    const guardarEdicion = async () => {
        try {
            await apiMaestras.actualizarCriterio(datos);
            obtenerCriterios();
            setOpenModal(false)
        } catch (error) {
            console.log(error);
        }
    }

    const deleteCriterio = async (datos: Criterios) => {
        try {
            await apiMaestras.eliminarCriterio(datos.id);
            obtenerCriterios();
        } catch (error) {
            console.log(error);
        }
    }


    const columns: any = [
        {
            title: "No.",
            width: 10,
            key: "idx",
             fixed: context.device === "md"? "left": false,
            render: (datos: any, record: any, index: number) => (
                <div>{index + 1}</div>
            )
        },
        {
            title: "Criterio",
            key: "nombre",
            dataIndex: "nombre",
            //  fixed: context.device === "md"? "left": false,
            width: 2000,
        },
        {
            title: (
                <div>
                    <div className="titleAcciones">Acciones</div>
                </div>
            ),
            key: 'actions',
            width: 150,
            fixed: context.device === "lg"? "right": false,
            render: (datos: Criterios) => (
                <div className="controls">
                    <DeleteOutlined onClick={() => deleteCriterio(datos)} />
                </div>
            )
        },
    ]

    return (
            <Modal
                // title="Crear criterios de evaluación"
                // style={{ top: 20, zIndex: 3, background: "transparent" }}
                visible={openModal}
                cancelButtonProps={{ style: { display: "none" } }}
                okButtonProps={{ style: { display: "none" } }}
                closable={false}

                width={1000}
                maskStyle={{
                    backgroundColor: "rgba(6, 100, 144 ,0.8)",
                  }}
                className="modal-postulacion-exitosa"
            >
                {isEdit ?
                    (
                        <div className="row-shadow">
                            <Row >
                                <Col span={24}>
                                    <div>Editar criterios de evaluación</div>
                                </Col>
                                <Divider />
                                <Col span={24}>
                                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                        Nombre del criterio de evaluación
                                    </span>
                                    <Input value={datos.nombre} onChange={(e) => setDatos({ ...datos, nombre: e.target.value })} />
                                </Col>

                            </Row>
                            <Row justify="end">
                                <Col>
                                    <Button className="button-azul-radius" onClick={guardarEdicion}>Guardar y Finalizar</Button>
                                </Col>
                            </Row>
                        </div>
                    )
                    :
                    (
                        <>
                            <div className="row-shadow">
                                <Row >
                                    <Col span={24}>
                                        <div className="mb-2">Crear criterios de evaluación</div>
                                    </Col>
                                    <Divider className="mt-2" />
                                    <Col span={24}>
                                        <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                            Nombre del criterio de evaluación
                                        </span>
                                        <Input value={criterio.nombre} onChange={(e) => setCriterio({...criterio, nombre: e.target.value})} />
                                    </Col>

                                </Row>
                                <Row justify="end">
                                    <Col>
                                        <Button className="button-azul-radius mb-0" onClick={addCriterio}>Guardar</Button>
                                    </Col>
                                </Row>
                            </div>


                            <div className="row-shadow mt-3">
                                <Row justify="space-between">
                                    <Col>
                                        <div>Criterios creados</div>
                                    </Col>
                                    <Col>
                                        <div>Total: <span className="font-color-F28C02 ">{criterios.length}</span></div>
                                    </Col>
                                </Row>
                                <Row >
                                    <Col>
                                        <Table
                                            dataSource={criterios}
                                            columns={columns}
                                            locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                                            style={{ borderTop: "1px solid #C4C4C4" }}
                                            size="small"
                                            bordered={false}
                                            pagination={false}
                                        />
                                    </Col>
                                </Row>
                                <Row justify="end" gutter={[24, 24]}>
                                    <Col>
                                        <Button className="button-gray-ghost mb-0" onClick={() => setOpenModal(false)}>Cancelar</Button>
                                    </Col>
                                    {/* <Col>
                                        <Button className="button-azul-radius" onClick={guardarTodo}>Cerrar</Button>
                                    </Col> */}
                                </Row>
                            </div>
                        </>
                    )
                }
            </Modal>

    )
}
